import * as z from 'zod';

import { LosId } from '../../BrandedIds';
import { DateString, NonNegativeMonetaryValue } from '../fields';

export const CreateEscrowPaymentRow = z.object({
  loanId: LosId,
  amount: NonNegativeMonetaryValue.describe('New statement escrow payment amount'),
  effectiveDate: DateString.describe(
    'Date the new statement escrow payment takes effect. Cannot be earlier than the latest statement',
  ),
});

export type CreateEscrowPaymentRow = z.infer<typeof CreateEscrowPaymentRow>;

export const CREATE_ESCROW_PAYMENT_ROW_REQUIRED_FIELDS = Object.keys(CreateEscrowPaymentRow.shape).filter(
  (key) => !CreateEscrowPaymentRow.shape[key as keyof typeof CreateEscrowPaymentRow.shape].isOptional(),
) as (keyof CreateEscrowPaymentRow)[];
